export { projectInfo };
export { PROJECT_VERSION };
const PROJECT_VERSION = '0.4.171';
const projectInfo = {
    projectName: 'Vike',
    projectVersion: PROJECT_VERSION
};
